<div class="absolute h-full w-full flex flex-column align-items-center justify-content-center left-0 top-0 z-5"
     style="background: rgba(255, 255, 255, 0.7)" *ngIf="isSelectedFileLoading">
    <p-progressSpinner ariaLabel="loading"/>
    <span class="text-xl">{{ 'sipo.file-is-uploading' | translate }}</span>
</div>

<div style="text-align: center;">
    <div class="min-h-full flex align-items-center justify-content-center w-full">
        <p-toast/>

        <p-fileUpload name="myfile[]" url="https://www.primefaces.org/cdn/api/upload.php"
                      [multiple]="true" accept=".pdf" maxFileSize="300000000" (onUpload)="onTemplatedUpload()"
                      (onSelect)="onSelectedFiles($event)" class="w-full">
            <ng-template pTemplate="header" let-files let-chooseCallback="chooseCallback"
                         let-clearCallback="clearCallback" let-uploadCallback="uploadCallback">
                <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                    <div class="flex gap-2">
                        <p-button (onClick)="choose($event, chooseCallback)" icon="pi pi-images"
                                  [rounded]="true" [outlined]="true"/>
                        <p-button (onClick)="clearCallback()" icon="pi pi-times" [rounded]="true"
                                  [outlined]="true" severity="danger"
                                  [disabled]="!files || files.length === 0"/>
                    </div>
                </div>
            </ng-template>
            <!-- pre-display of pdf begin -->
            <ng-template pTemplate="content" let-files let-uploadedFiles="uploadedFiles"
                         let-removeFileCallback="removeFileCallback"
                         let-removeUploadedFileCallback="removeUploadedFileCallback">
                <div *ngIf="files?.length > 0">
                    <div class="flex flex-wrap p-0 sm:p-5 gap-5">
                        <div *ngFor="let file of files; let i = index"
                             class="card m-0 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
                            <i class="pi pi-file-pdf text-3xl text-red-500"></i>
                            <span class="font-semibold">{{ file.name }}</span>
                            <p-button icon="pi pi-times" size="small"
                                      (onClick)="onRemoveTemplatingFile($event, file, removeFileCallback, i)"
                                      [outlined]="true" [rounded]="true" severity="danger"/>
                        </div>
                    </div>
                </div>
            </ng-template>
            <!-- pre-display of pdf begin -->
            <ng-template pTemplate="file"></ng-template>
            <ng-template pTemplate="empty">
                <div class="flex align-items-center justify-content-center flex-column h-25rem">
                    <i *ngIf="files.length < 1"
                       class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400 hidden md:inline-block"></i>
                    <p class="text-1xl font-bold width-half">
                        {{ 'sipo.sign-component.upload-document-component.document-upload-info' |translate }}
                    </p>
                    <div class="mt-5">
                        <p-fileUpload mode="basic"
                                      styleClass="bg-white text-primary-400 hover:bg-primary-400 hover:text-white"
                                      [chooseLabel]="'sipo.choose' | translate" chooseIcon="pi pi-upload"
                                      name="myfile[]"
                                      url="https://www.primefaces.org/cdn/api/upload.php" accept=".pdf"
                                      maxFileSize="30000000" (onUpload)="onTemplatedUpload()"
                                      (onSelect)="onSelectedFiles($event)"/>
                    </div>
                    <p class="mt-4 mb-0 hidden md:block"
                       *ngIf="files.length < 1">{{ 'sipo.drag-and-drop-explanation-desktop' |translate }}</p>
                    <p class="mt-4 mb-0 md:hidden"
                       *ngIf="files.length < 1">{{ 'sipo.drag-and-drop-explanation-mobile' | translate }}
                    </p>
                </div>
            </ng-template>
        </p-fileUpload>
    </div>
</div>
